import { ReactElement } from 'react';
import classes from './TrustpulseLogo.module.css';

/** The logo in the header of the public pages, where the name of the product is the only heading */
export const TrustpulseLogo = (): ReactElement => (
  <img src="/trustpulse-logo.png" alt="Trustpulse" width={380} height={65} className={classes.logo} />
);
